import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    border: '1px solid rgba(105, 105, 105, .5)',
    padding: '10px',
  },

  media: {
    height: 0,
    paddingTop: '50%',
    backgroundSize: 'contain'
  },

  cardContent: {
    display: 'flex',
    justifyContent: 'start',
    WebkitFlexDirection: 'column',
    color: '#2a4361'
  },

  span: {
    color: 'rgb(210, 63, 87)'
  },

  cartActions: {
    justifyContent: 'space-between',
  },

  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignContent: 'center',
  },

  inc: {
    background: '#9b3eed',
  },

  dec: {
    background: '#f56656',
  },

  bottom: {
    width: '100%',
    height: '100%'
  },

  container: {
    overflow: 'hidden',
    width: '56px',
    height: '100%',
    textAlign: 'center'
  },

  IconButton: {
    width: '50px',
    height: '50px',
    color: '#2a4361',
    background: '#f5f5f5',
    "&:hover": {
      // boxShadow: "1px 1px 1px 1px rgba(15, 52, 96)"
      border: '1px  solid rgba(15, 52, 96, .2)'
    }
  }
}));